// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".call-to-action[data-v-cb879d44]{padding:.5rem;color:#666;font-size:.875rem;font-weight:400;letter-spacing:0;line-height:18px;min-height:18px;text-align:center}", ""]);
// Exports
module.exports = exports;
